import classNames from 'classnames';
import StepHeader from '../../Navigation/StepHeader';
import { AnimatePresence, motion } from 'framer-motion';
import { Shape3, Shape2 } from '../../CustomIcon';
var classes = {
    base: 'fixed w-screen h-screen top-0 left-0 overflow-hidden flex flex-col justify-center items-center bg-brand-01 dark z-[110]',
    mainCol: 'flex flex-col items-center md:w-[36rem] mx-auto text-center',
    bg: {
        1: 'absolute -top-[38rem] lg:-top-[32rem] -right-[22rem]',
        2: 'absolute left-0 top-0 h-full w-auto origin-left',
        3: 'absolute -bottom-[36rem] -left-[24rem] md:-bottom-[48rem] md:-left-[30rem]',
        4: '',
    },
};
var modalVariant = {
    hidden: { opacity: 0 },
    show: {
        opacity: 1,
        transition: {
            staggerChildren: 0.02,
            delayChildren: 0.1,
        },
    },
    exit: { opacity: 0 },
};
var bg1Variant = {
    hidden: {
        rotate: 90,
        scale: 0,
        opacity: 0,
    },
    visible: {
        rotate: 0,
        scale: 1,
        opacity: 1,
        transition: {
            duration: 0.35,
        },
    },
    exit: {
        scale: 0,
        rotate: 90,
        opacity: 0,
    },
};
var bg2Variant = {
    hidden: {
        x: '-50',
        scale: 1.5,
    },
    visible: {
        x: 0,
        scale: 1,
        transition: {
            duration: 0.25,
            ease: 'easeOut',
        },
    },
    exit: {
        x: '-50',
        scale: 1.5,
    },
};
var bg3Variant = {
    hidden: {
        scale: 0,
        rotate: -90,
        opacity: 0,
    },
    visible: {
        scale: 1,
        rotate: 0,
        opacity: 1,
        transition: {
            duration: 0.35,
        },
    },
    exit: {
        scale: 0,
        rotate: -90,
        opacity: 0,
    },
};
var ModalFull = function (_a) {
    var children = _a.children, open = _a.open, _b = _a.bgType, bgType = _b === void 0 ? 1 : _b, className = _a.className, mainColClassName = _a.mainColClassName, duration = _a.duration;
    return (<AnimatePresence initial={false} exitBeforeEnter={true} onExitComplete={function () { return null; }}>
      {open && (<motion.div className={classNames(classes.base, className)} variants={modalVariant} initial="hidden" animate="show" exit="exit">
          <StepHeader className="absolute top-0 left-0 w-full"/>
          {duration && (<motion.div initial={{ width: 0 }} animate={{
                    width: '100%',
                    transition: {
                        duration: duration / 1000,
                    },
                }} exit={{ width: 0 }} className="absolute top-24 left-0 z-10 h-1 bg-secondary-04"></motion.div>)}
          <div className="container z-10">
            <div className={classNames(classes.mainCol, mainColClassName)}>{children}</div>
          </div>

          {bgType === 1 && (<motion.div className={classNames(classes.bg[bgType])} variants={bg1Variant} initial="hidden" animate="visible" exit="exit">
              <Shape3 size={836}/>
            </motion.div>)}

          {bgType === 2 && (<motion.div className={classNames(classes.bg[bgType])} variants={bg2Variant} initial="hidden" animate="visible" exit="exit">
              <svg xmlns="http://www.w3.org/2000/svg" width="610" height="935" viewBox="0 0 610 935" className="h-full w-auto">
                <path d="M-145 703V-52H610C610 364.977 271.976 703 -145 703Z" fill="#221657"/>
                <path d="M-145 588V1246H513C513 882.595 218.404 588 -145 588Z" fill="#503D84"/>
                <path fillRule="evenodd" clipRule="evenodd" d="M-145 587.859V703.344C-46.2872 703.344 48.0009 684.4 134.427 649.949C49.61 610.118 -45.0954 587.859 -145 587.859Z" fill="#C9252F"/>
              </svg>
            </motion.div>)}

          {bgType === 3 && (<motion.div className={classNames(classes.bg[bgType])} variants={bg3Variant} initial="hidden" animate="visible" exit="exit">
              <Shape2 size={1088} className="max-md:h-[55rem] max-md:w-[55rem]"/>
            </motion.div>)}

          {bgType === 4 && <div></div>}
        </motion.div>)}
    </AnimatePresence>);
};
export default ModalFull;
